import styled, { css } from 'styled-components';
import { token } from '@zillow/constellation';

export const Container = styled.div`
    position: absolute;
    display: flex;
    justify-content: space-between;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
`;

export const Dot = styled.div<{ isActive: boolean }>`
    width: 16px;
    height: 16px;
    border: 4px solid ${token('colors.white')};
    border-radius: 50%;
    cursor: pointer;

    background: ${({ isActive }) =>
        css`
            ${isActive ? token('colors.brand') : token('colors.gray300')}
        `};
`;
